export enum FileStatus {
  Rejected = "Rejected",
  Approved = "Approved",
  Uploaded = "Uploaded",
  Uploading = "Uploading",
  Failed = "Failed",
}
